export const dateFormat = "YYYY-MM-DD[T]HH:mm:ss.SSS[+0000]";
export const taskFieldInputShortDateFormat = "YYYY-MM-DD";
export const localInputShortDateFormat = "DD/MM/YYYY";
